import { FC, useCallback } from 'react';
import { Checkbox } from '@mui/material';
import { useSnapshot } from 'valtio';
import ApplicationsStore from '../stores/applications-store';
import { selectApp } from '../actions/applications-actions';
import { stopPropagation } from '../../common/common-utils';

const RowCheckboxContainer: FC<React.PropsWithChildren<RowCheckboxProps>> = ({
  appId,
  isFakeApp,
}) => {
  const { selected } = useSnapshot(ApplicationsStore);
  const onChange = useCallback((event: React.ChangeEvent<HTMLInputElement>) => {
    const { id } = event.target;
    id && selectApp(event.target.id);
    return false;
  }, []);
  return (
    <Checkbox
      id={appId}
      disableRipple
      disabled={isFakeApp}
      size='small'
      checked={!!selected[appId]}
      onChange={onChange}
      onClick={stopPropagation}
    />
  );
};

export interface RowCheckboxProps {
  appId: string;
  isFakeApp: boolean;
}

export default RowCheckboxContainer;
